<template>
    <div class="entiretyClass">
        <common-left @hasSubMenu="hasSubMenu" ref="menuRef"></common-left>
        <div class="content">
            <common-top @messageLog="messageLog"></common-top>
            <div class="commonCenter" :style="hasSubMenuValue?'padding-left:100px':'padding-left:0'">
                <el-scrollbar style="height: 100%;">
                    <router-view @hompageLog='hompageLog'></router-view>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import commonLeft from './layout/common_left'
    import commonTop from './layout/common_top'
    export default {
        name: "index",
        data(){
            return{
                hasSubMenuValue:false,
                setIn: null,
            }
        },
        components: {
            commonLeft,
            commonTop
        },
        mounted(){
          this.setIn = setInterval(() => {
              clearInterval(this.setIn);
              this.childBarBar();
          }, 500);
        },
        methods: {
            // 获取对应的路由， 展示对应的左侧子条形栏
            childBarBar(){
                let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
                if (location.href.indexOf('productDisplay') > 0) {
                  menuList.some(item => {

                      if(item.url === '/productDisplay'){
                          this.resetSetItem('menuActiveId',item.uuid)
                          this.$refs.menuRef.routeHandle(item.uuid)
                          return true
                      } else {
                          this.childrenRoute(item.children,'/productDisplay',item)
                      }
                  })
                }
                if (location.href.indexOf('modelManagement') > 0) {
                  menuList.some(item => {
                      if(item.url === '/modelManagement'){
                          this.resetSetItem('menuActiveId',item.uuid)
                          this.$refs.menuRef.routeHandle(item.uuid)
                          return true
                      } else {
                          this.childrenRoute(item.children,'/modelManagement',item)
                      }
                  })
                }
                if (location.href.indexOf('storeMessage') > 0) {
                  menuList.some(item => {
                      if(item.url === '/storeMessage'){
                          this.resetSetItem('menuActiveId',item.uuid)
                          this.$refs.menuRef.routeHandle(item.uuid)
                          return true
                      } else {
                          this.childrenRoute(item.children,'/storeMessage',item)
                      }
                  })
                }

            },
            hasSubMenu(val){
                this.hasSubMenuValue = val
            },
            // // 消息定位
            // messageLog(){
            //     //消息菜单的id
            //     this.resetSetItem('menuActiveId','13')
            //     this.$refs.menuRef.routeHandle('13')
            // }
            // 消息定位
            messageLog(){
                let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
                menuList.some(item => {
                    if(item.url === '/stationMessageLog'){
                        this.resetSetItem('menuActiveId',item.uuid)
                        this.$refs.menuRef.routeHandle(item.uuid)
                        return true
                    } else {
                        this.childrenRoute(item.children,'/stationMessageLog',item)
                    }
                })
            },
            hompageLog(type){
                let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
                if (type == 'order') {
                    menuList.some(item => {
                        if(item.url === '/designOrderList'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/designOrderList',item)
                        }
                    })
                }else if (type == 'hot') {
                    menuList.some(item => {
                        if(item.url === '/modelManagement'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/modelManagement',item)
                        }
                    })
                }else if (type == 'adr') {
                    menuList.some(item => {
                        if(item.url === '/storeMessage'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/storeMessage',item)
                        }
                    })
                }else if (type == 'bank') {
                    menuList.some(item => {
                        if(item.url === '/bankCardManage'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/bankCardManage',item)
                        }
                    })
                }else if (type == 'plane') {
                    menuList.some(item => {
                        if(item.url === '/worksManagement'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/worksManagement',item)
                        }
                    })
                }else if (type == 'model') {
                    menuList.some(item => {
                        if(item.url === '/modelManagement'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/modelManagement',item)
                        }
                    })
                }else if (type == 'accountManagement') {
                    menuList.some(item => {
                        if(item.url === '/accountManagement'){
                            this.resetSetItem('menuActiveId',item.uuid)
                            this.routeHandle(item.uuid)
                            return true
                        } else {
                            this.childrenRoute(item.children,'/accountManagement',item)
                        }
                    })
                }
            },
            // 子菜单
            childrenRoute(children,url,item){
                if(children){
                    children.some(child =>{
                        if(child.url === url){
                            this.resetSetItem('menuActiveId',child.uuid)
                            this.$refs.menuRef.routeHandle(child.uuid)
                            return true
                        } else {
                            this.childrenRoute(child.children,url,item)
                        }
                    })
                }
            }

        }
    }
</script>

<style scoped lang="less">
    .entiretyClass{
        width: 100%;
        height: 100%;
        .content{
            margin-left: 90px;
            height: 100%;
            background: #fff;
            border-top-left-radius: 20px;
            position: relative;
            .commonCenter{
                width: 100%;
                height: 100%;
                padding-top: 60px;
                /deep/.el-scrollbar__wrap {
                    overflow-x: unset;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue